import React from 'react';
import './App.scss';
import Dashboard from './layout/Dashboard/Dashboard'

const App = (props) => (
  <div className="app-wrapper">
    <Dashboard/>
  </div>
);

export default App;
